import React, { useEffect, useState } from 'react';
import styles from './PlatformAdminController.module.scss';

import { $t } from "../../helpers/translator";
import Toggle from "../miscellaneous/Toggle/Toggle";
import Input from "../miscellaneous/Input/Input";
import api from "../../helpers/api";
import { setAlert } from "../../store/alerts-slice";
import { useDispatch } from "react-redux";
import { $validate } from "../../helpers/formValidator";
import { BiInfinite } from "react-icons/bi";
import Loader from "../miscellaneous/Loader/Loader";


const PlatformAdminController = (props) => {
    const dispatch = useDispatch();
    const [ platform, setPlatform ] = useState(null);
    const [ pulses, setPulses ] = useState(null);
    const [ newPulseCount, setNewPulseCount ] = useState(0);
    const [ newPulseCountError, setNewPulseCountError ] = useState('');
    const [ loading, setLoading ] = useState(false);


    useEffect(async () => {
        await init();
    }, [ props.platformId ])

    useEffect(() => {
        validatePulseCount();
    }, [ newPulseCount ]);

    async function init() {
        if (!props.platformId) {
            return;
        }

        try {
            let res = await api.get(`platform?id=${props.platformId}`);
            let pulsesRes = await api.get(`platform/${props.platformId}/pulses`)

            if (res.success && res.data && res.data.data && res.data.data.data && res.data.data.data[ 0 ]) {
                // console.log('resres', res.data.data.data[0])
                setPlatform(res.data.data.data[ 0 ])
                setPulses(pulsesRes.data.data.pulses)
                setNewPulseCount(pulsesRes.data.data.pulses)

                // console.log('>', pulsesRes.data.data.pulses)
            }
        } catch (e) {
            console.error(e)
        }
    }


    async function editPlatform(payload) {
        setLoading(true)
        try {
            // console.log(payload, this.state.platform.is_unlimited)
            let res = await api.patch(`platform/${props.platformId}`, payload);
            // console.log(res)
            if (!res.success) {
                dispatch(setAlert({ type: 'error' }));
                return;
            }

            await init();

            dispatch(setAlert({ type: 'success' }));
        } catch (e) {
            console.error(e);
            dispatch(setAlert({ type: 'error' }));
        } finally {
            setLoading(false)
        }

    }

    async function editPulseNumber(payload) {
        if (newPulseCountError) {
            return;
        }

        setLoading(true)

        try {
            let res = await api.post(`platform/${props.platformId}/pulses`, payload);

            if (res && res.success) {
                setPulses(res.data.data.pulses)
                dispatch(setAlert({ type: 'success' }));
                return;
            }
            dispatch(setAlert({ type: 'error' }));
        } catch (e) {
            console.error(e)
            dispatch(setAlert({ type: 'error' }));
        } finally {
            setLoading(false)
        }
    }

    function validatePulseCount(value) {
        let errorsArr = $validate(newPulseCount, [ 'required', 'numeric', 'max(1000000)', 'min(-1000000)' ])

        // console.log(errorsArr);
        if (errorsArr) {
            setNewPulseCountError(errorsArr[ 0 ])
            return;
        }
        setNewPulseCountError('')
    }

    return (
        <div className={ styles.container }>
            { loading ?
                <div className={ styles.loaderContainer }>
                    <Loader />
                </div>
                :
                null }
            { platform ?
                <div className={ styles.flexContainer }>
                    <div className={ styles.padding }>
                        <Toggle
                            onText={ $t('global.machines.unlimited') }
                            offText={ $t('global.machines.limited') }
                            status={ platform.is_unlimited }
                            onChange={ async (status) => {
                                await editPlatform({ is_unlimited: status })
                            } } />
                    </div>


                    <div className={ styles.grayedContainer }>
                        { platform.is_unlimited ?
                            <div className={ styles.grayed }>
                                <BiInfinite />
                            </div>
                            :
                            null }

                        <div className={ styles.pulseNumberAndText }>
                            <div>{ $t('global.machines.remainingPulses') }</div>
                            <div className={ styles.pulseNumber }>{ pulses }</div>
                        </div>

                        <div style={ { margin: '0 5px' } }>
                            <Input className={ styles.padding }
                                type={ 'number' }
                                value={ newPulseCount }
                                onChange={ (data) => {
                                    setNewPulseCount(data.target.value)
                                } } />
                        </div>
                        <div className={ `${newPulseCountError ? 'alma-button-disabled' : 'alma-button'}` }
                            onClick={ (data) => editPulseNumber({ pulses: newPulseCount }) }>{ $t('global.machines.update') }</div>
                        <div className={ `${'alma-field-error'}` } style={ { minHeight: '21px' } }>{ newPulseCountError }</div>
                    </div>

                </div>
                :
                <div>no platformId provided</div> }
        </div>
    );
}

PlatformAdminController.defaultProps = {
    platform: null,
}


export default PlatformAdminController;
